<template>
  <div class="bg-black">
    <div class="home-panel flex relative items-end justify-center w-screen h-ipad">
      <img src='/images/six-logo.svg' class='home-logo' />
      <router-link to='/floors' class='border-solid border-2 border-white px-6 py-5 uppercase mb-12'>
        Customize Your Layout
      </router-link>
    </div>
    <div class="container mx-auto w-container mt-20">
      <div class="uppercase text-center mb-6">Gallery</div>
      <div class="flex flex-wrap justify-center mb-24">
        <div
          v-for='(image, i) in images'
          v-bind:key='image'
          class="home-image-icon-container ml-6 mr-6 mb-12 cursor-pointer"
          @click='toggleModal(i)'>
          <img class="home-image-icon h-24 w-24" :src="image+'thumb.jpg'" />
        </div>
      </div>
    </div>

    <ModalGallery
      :images='images'
      :isOpen='modalIsOpen'
      :navigateTo='slideIndex'
      @on-close='toggleModal'/>
  </div>
</template>

<script>
import ModalGallery from '@/components/ModalGallery.vue'

export default {
  name: 'home',

  data () {
    return {
      modalIsOpen: false,
      slideIndex: 0,
      images: [
        '/images/home-gallery/exterior',
        // '/images/home-gallery/home1',
        // '/images/home-gallery/home2',
        // '/images/home-gallery/home3',
        // '/images/light-finish/light1',
        // '/images/light-finish/light2',
        // '/images/light-finish/light3',
        // '/images/dark-finish/dark1',
        // '/images/dark-finish/dark2',
        // '/images/dark-finish/dark3'
        '/images/home-gallery/lobby_055',
        '/images/home-gallery/lobby_058',
        '/images/home-gallery/lobby_059',
        '/images/home-gallery/lobby_062',
        '/images/home-gallery/lobby_063',
        '/images/light-finish/6fl_030',
        '/images/light-finish/6fl_034',
        '/images/light-finish/6fl_036',
        '/images/light-finish/6fl_042',
        '/images/dark-finish/16fl_002',
        '/images/dark-finish/16fl_004',
        '/images/dark-finish/16fl_005',
        '/images/dark-finish/16fl_016',
        '/images/dark-finish/16fl_017',
        '/images/dark-finish/16fl_018'
      ]
    }
  },

  components: {
    ModalGallery
  },

  methods: {
    toggleModal (i) {
      this.slideIndex = i
      this.modalIsOpen = !this.modalIsOpen
    }
  }
}
</script>

<style>
  .home-panel {
    height: 100vh;
    background: url('/images/bg.jpg');
    background-size: cover;
    background-position: bottom center;
    min-height: 768px;
  }

  .home-logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .home-image-icon {
    object-fit: cover;
  }


</style>
